import { validateWholeInteger } from "../../inputValidation";
const errorMessage = 'This field is required';
const isRequiredAndSelected = previewEntry => {
  const {
    value,
    required
  } = previewEntry;
  if (required && !value) {
    return errorMessage;
  }
};
const validateDefaultValue = data => {
  if (data.default) {
    if (validateWholeInteger(data.default) === false) {
      return 'Default value must be a whole number';
    } else if (data.default.match(/[0-5]/g) === null) {
      return 'Default value must be between 0 and 5';
    }
  }
};
export default [{
  validation: isRequiredAndSelected,
  type: 'required'
}, {
  validation: validateDefaultValue,
  type: 'format'
}];